import { DeleteOutlineIcon } from '@carboncopyco/icons';
import { Button, Modal, TextBase } from '@carboncopyco/ui';

export interface DangerModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
  confirmLabel?: string;
}

export const DangerModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message = 'Are you sure?',
  confirmLabel = 'Delete',
}: DangerModalProps) => {
  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
    >
      <div className="w-ds-normal-modal">
        <div className="my-5">
          <TextBase
            color="text-ds-natural-600"
            label={message}
          />
        </div>
        <div className="flex items-center justify-end">
          <div className="ml-4">
            <Button
              secondary
              link
              label="Cancel"
              onClick={onClose}
            />
          </div>
          <div className="ml-4">
            <Button
              label={confirmLabel}
              leftIcon={<DeleteOutlineIcon />}
              danger
              onClick={onConfirm}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
